import React from 'react';
import { Container, Image, Grid } from 'semantic-ui-react';
import SiteHeader from '../SiteHeader';
import SiteFooter from '../SiteFooter';

export default function roundUpPosterUrl() {
  const params = new URLSearchParams(window.location.search);
  const imageSrc = params.get('url');

  return (
    <>
      <SiteHeader />
      <Container centered style={{ paddingTop: '2rem' }}>
        <Grid centered>
          <Image alt="Round Up Poster" size="big" src={imageSrc} />
        </Grid>
      </Container>
      <SiteFooter />
    </>
  );
}
